/*************************************************/
/* PRODUCTS-ACCORDION                            */
/*************************************************/
import customEventsNames from '../customEventsNames';
export function productsAccordion() {
    const productsAccordionContainerSelector = ".products-accordion__images-container";
    const productsAccordionelector = ".products-accordion__image";
    const accordionImageActiveClass = "products-accordion__image--active";
    const accordionImageFallbackClass = "products-accordion__image--fallback";

    const init = () => {
        const imageContainers = document.querySelectorAll(productsAccordionContainerSelector);
        if (imageContainers) {
            imageContainers.forEach(container => {

                const images = container.querySelectorAll(productsAccordionelector);
                if (images[1].classList.contains(accordionImageActiveClass)) {
                    images[0].classList.remove(accordionImageActiveClass);
                }

                container.addEventListener(customEventsNames.accordionActivateItemEventName, e => {
                    let i = 0;
                    container.querySelectorAll(productsAccordionelector).forEach(image => {
                        image.classList.remove(accordionImageActiveClass);
                        if (image.classList.contains(accordionImageFallbackClass)) return;
                        if (i == e.detail.accordionItemIndex) {
                            image.classList.add(accordionImageActiveClass);
                        }
                        i++;
                    });
                });
            });
        }
    };

    init();
}